import progressBar from '../../components/_progress_bar';

/**
 * タスクカテゴリのひと枠コンポーネント
 */
export default {
    name: 'taskCategoryWrap',
    template: '#task_category_wrap_template',
    props: {
        // 達成フラグリスト
        tasks: {
            type: Object,
            default: () => ({}),
            require: true
        },
        // リンク先
        type: {
            type: String,
            require: true
        },
    },
    computed: {
        // プログレスバー用各タスク完了情報
        progressTasks: function () {
            if (typeof this.tasks[this.type] === 'undefined') {
                return {};
            }
            return this.tasks[this.type];
        },
        // リンク
        link: function () {
            return '/guide/' + this.type;
        }
    },
    components: {
        // プログレスバーコンポーネント
        'progress-bar': progressBar,
    },
};
